import type { Dispatch, ReactNode, SetStateAction } from "react";
import { createContext, useContext, useEffect, useState } from "react";

const EnterprisePageBannerContext = createContext<ReactNode>(null);
const EnterprisePageBannerSetterContext = createContext<Dispatch<
  SetStateAction<ReactNode>
> | null>(null);

export function EnterprisePageChromeProvider({
  children,
}: {
  children: ReactNode;
}) {
  const [banner, setBanner] = useState<ReactNode>(null);

  return (
    <EnterprisePageBannerSetterContext.Provider value={setBanner}>
      <EnterprisePageBannerContext.Provider value={banner}>
        {children}
      </EnterprisePageBannerContext.Provider>
    </EnterprisePageBannerSetterContext.Provider>
  );
}

export function useEnterprisePageBanner() {
  return useContext(EnterprisePageBannerContext);
}

export function useRegisterEnterprisePageBanner(
  banner: ReactNode,
  dependencies: readonly unknown[],
) {
  const setBanner = useContext(EnterprisePageBannerSetterContext);

  if (!setBanner) {
    throw new Error(
      "useRegisterEnterprisePageBanner must be used within EnterprisePageChromeProvider",
    );
  }

  // biome-ignore lint/correctness/useExhaustiveDependencies: Callers provide dependencies so JSX banner identity does not re-register on every render.
  useEffect(() => {
    setBanner(banner);
    return () => setBanner(null);
  }, [setBanner, ...dependencies]);
}
